import { LoginAbstractPageComponent, LoaderSpinnerComponent } from '@aston/foundation/components';
import { Component, inject, OnInit } from '@angular/core';

import { AuthenticationService } from '../../services';

@Component({
	template: `<loader-spinner [model]="formLoader" />`,
	imports: [LoaderSpinnerComponent]
})
export class LoginPageComponent extends LoginAbstractPageComponent implements OnInit {
	protected authenticationService = inject(AuthenticationService)
	ngOnInit() {
		this.notLoggedInFallback$.subscribe(_ => this.authenticationService.login())
	}
}
